export const ANALYTICS_CONSENT_STORAGE_KEY = 'collins.analytics-consent.v1'

export const analyticsConsent = {
  accepted: 'accepted',
  essentialOnly: 'essential-only',
}

const isBrowser = () => typeof window !== 'undefined'

export const getAnalyticsConsent = () => {
  if (!isBrowser()) return analyticsConsent.essentialOnly

  try {
    const value = window.localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY)
    return Object.values(analyticsConsent).includes(value)
      ? value
      : analyticsConsent.essentialOnly
  } catch (error) {
    return analyticsConsent.essentialOnly
  }
}

export const hasAnalyticsConsentDecision = () => {
  if (!isBrowser()) return false

  try {
    return Object.values(analyticsConsent).includes(
      window.localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY)
    )
  } catch (error) {
    return false
  }
}

export const hasAcceptedAnalytics = () =>
  getAnalyticsConsent() === analyticsConsent.accepted

export const setAnalyticsConsent = (consent) => {
  if (!Object.values(analyticsConsent).includes(consent)) {
    throw new Error(`Unsupported analytics consent value: ${consent}`)
  }

  if (!isBrowser()) return consent

  try {
    window.localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, consent)
  } catch (error) {
    // The in-memory event still lets the current page honor a visitor's choice.
  }

  window.dispatchEvent(
    new CustomEvent('collins:analytics-consent-change', { detail: consent })
  )

  return consent
}
